<script setup lang="ts">
import { inject } from 'vue'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { deleteUser } from '~/layers/cms/app/composables/cms'

const toast = usePrimeToast()
const dialogRef = inject<DialogRef>('dialogRef')

interface DialogRef {
  value: {
    data: {
      choosenUserId: number
    }
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const removeUser = async () => {
  if (!dialogRef || !dialogRef.value.data.choosenUserId) return
  const response = await deleteUser(dialogRef.value.data.choosenUserId)
  if (!response.status_ok) {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Nie udało usunąć usera',
      life: 3000
    })
  } else {
    toast.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Poprawnie usunięto usera',
      life: 3000
    })
  }
  closeDialog()
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <Button
      type="button"
      label="Potwierdź"
      severity="primary"
      @click="removeUser"
    />
    <Button
      type="button"
      label="Anuluj"
      severity="primary"
      @click="closeDialog"
    />
  </div>
</template>
